import React from "react";
import { Paper, Stack, SxProps, Theme, Typography } from "@mui/material";

export interface WcSubHeaderProps {
  children: React.ReactNode;
  height?: number | string;
  width?: string | number;
  title?: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const WcSubHeader = ({ children, height, width, title, sx }: WcSubHeaderProps) => (
  <Stack id="SubHeader" marginBottom={2} width={"100%"}>
    <Paper id="SubHeader_Paper">
      <Stack
        id="SubHeader_InnerStack"
        width={width ? width : "100%"}
        height={height ? height : "100%"}
        minHeight={64}
        spacing={2}
        paddingY={2}
        paddingX={6}
        justifyContent={"space-between"}
        alignItems={"center"}
        direction={"row"}
        sx={[...(Array.isArray(sx) ? sx : [sx])]}
      >
        <Stack direction={"row"}>{title}</Stack>
        <Stack direction={"row"} justifyContent={"flex-end"}>
          {children}
        </Stack>
      </Stack>
    </Paper>
  </Stack>
);
